import baseTheme from '../baseTheme';
export var MuiTableRow = {
    root: {
        '&:not(:last-child)': {
            borderBottom: "1px solid rgba(0,0,0,0.12)",
        },
    },
    head: {
        backgroundColor: baseTheme.palette.grey[100],
        color: baseTheme.palette.text.primary,
    },
};
//# sourceMappingURL=MuiTableRow.js.map